const FATURAS = '/faturas';
const NEGOCIACOES = '/negociacoes';

export const routes = {
  login: '/login',
  invoiceList: FATURAS,
  invoiceDetailPath: `${FATURAS}/:id`,
  invoiceDetail: (id: string) => `${FATURAS}/${id}`,
  negotiationList: NEGOCIACOES,
  negotiationDetailPath: `${NEGOCIACOES}/:id`,
  negotiationDetail: (id: string) => `${NEGOCIACOES}/${id}`,
} as const;

// Aliases legados em inglês → canônico em pt-BR. Mantidos enquanto links já
// compartilhados (WhatsApp, e-mail) ainda chegam em /invoices ou /negotiations.
// Quando o backend migrar os geradores e os links antigos expirarem, esse bloco
// (e os Routes derivados em App.tsx) pode sumir inteiro.
const LEGACY_ROUTE_MAP = [
  ['/invoices', FATURAS],
  ['/negotiations', NEGOCIACOES],
] as const;

export const LEGACY_ROUTE_PATTERNS = LEGACY_ROUTE_MAP.flatMap(([legacy]) => [legacy, `${legacy}/:id`]);

export function rewriteLegacyPath(pathname: string): string {
  for (const [legacy, canonical] of LEGACY_ROUTE_MAP) {
    if (pathname === legacy || pathname.startsWith(`${legacy}/`)) {
      return canonical + pathname.slice(legacy.length);
    }
  }
  return pathname;
}
